import { connect } from 'react-redux';
import { getLocations } from '../locations';
import { injectIntl, intlShape } from 'react-intl';
import Helmet from 'react-helmet';
import Page from '../../app/components/Page';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {SessionRequired} from '../../../lib/api/components/SessionRequired';
import {ActiveTenantRequired} from '../../../lib/api/components/ActiveTenantRequired';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {Route, Switch, withRouter} from "react-router-dom";
import List from "./List";
import Creator from "./Creator";
import Editor from "./Editor";
import GlobalError from "../../app/components/GlobalError";
import {NoMatch} from "../../app/containers/NoMatch";
import AddressbookCreator from "./AddressbookCreator";
import AddressbookManager from "./AddressbookManager";
import Management from "./AddressbookList";

@injectIntl
export class Addressbook extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        session: ImmutablePropTypes.map.isRequired,
        intl: intlShape,
    }

    componentWillMount() {
        this.props.dispatch(getLocations({}, { spinner: 'addressbook' }));
    }

    render() {
        const { dispatch, session, tenant } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <Page>
                <Helmet title={formatMessage({ id: 'frontend.pagetitle.my_addressbook' })} />
                <Page.Header />
                <GlobalError />
                <SessionRequired dispatch={dispatch} session={session}>
                    <ActiveTenantRequired dispatch={dispatch} session={session} tenant={tenant}>
                        <Switch>
                            <Route exact path='/addressbook' component={List} />
                            <Route exact path='/addressbook/new' component={AddressbookCreator} />
                            <Route exact path='/addressbook/manage' component={Management} />
                            <Route exact path='/addressbook/manage/:addressbookId' component={AddressbookManager} />
                            <Route exact path='/addressbook/address/new' component={Creator} />
                            <Route exact path='/addressbook/address/edit/:location' component={Editor} />
                            <Route component={NoMatch}/>
                        </Switch>
                    </ActiveTenantRequired>
                </SessionRequired>
                <Page.Footer />
            </Page>
        );
    }
}

export default withRouter(connect(state => ({
    session: state.session,
    tenant: state.tenant,
}))(Addressbook));
